import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Card from '../Card';
import * as Style from './style';
import { LoaderFull } from '../../Loader';
import color from '../../../config/colors.json';

const CardChartInfo = ({
    label, amount, isLoading, hasPlan, error, tooltipText, tooltipId,
}) => {
    const dataRender = () => {
		if (!hasPlan) return <Style.Ammount>{amount}</Style.Ammount>;
		if (isLoading) return <LoaderFull />;
		return <Style.Ammount>{amount}</Style.Ammount>;
    };

    return (
	<Card
		noShadow
		border={`1px solid ${color.lightGrey43}`}
		padding={!error ? '8.7px 11px 36px' : '8.7px 11px'}
		height="120px"
	>
		{ !error ? (
			<>
				<Style.TitleContainer>
					<Style.Title>{label}</Style.Title>
					<Style.Icon data-tip="React-tooltip" data-for={tooltipId}>
						<AiOutlineInfoCircle />
					</Style.Icon>
					<ReactTooltip place="bottom" effect="solid" id={tooltipId}>
						<span style={{ width: '300px', display: 'block' }}>{ tooltipText }</span>
					</ReactTooltip>
				</Style.TitleContainer>
				<Style.Data>
					{ dataRender() }
				</Style.Data>
			</>
		) : (
			<Style.Error>
				<span>Algo saiu errado. <br />Por favor, tente novamente mais tarde</span>
			</Style.Error>
        )}
	</Card>
    );
};

PropTypes.CardChartInfo = {
	label: PropTypes.string.isRequired,
	amount: PropTypes.number.isRequired,
	isLoading: PropTypes.bool.isRequired,
	hasPlan: PropTypes.bool.isRequired,
	error: PropTypes.bool.isRequired,
	tooltipText: PropTypes.string.isRequired,
	tooltipId: PropTypes.string.isRequired,
};

export default CardChartInfo;
